import React, {Component} from 'react';
import {connect} from 'react-redux';
import DateSearchModal from '@homeaway/react-search-modal';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import {
    goToSerp,
    hideDatesPopup,
    setArrivalDate,
    setDepartureDate,
    updateSearchGuests,
    setKeywords,
} from '../../../actions/search';
import {UNREFINED_KEY} from '../../../utils/listings';

import './styles.less';

export function mapStateToProps({config, destination, modules, search}) {
    const destinationSegmentKey =
        destination.segmentFilters && destination.segmentFilters.key
            ? destination.segmentFilters.key
            : UNREFINED_KEY;

    return {
        adultsCount: search.adults,
        altImgText: search.propertyName,
        arrivalDate: search.arrivalDate,
        childrenCount: search.children,
        suppressFilters: search.suppressFilters || false,
        dateModalSerpKeywords: search.dateModalSerpKeywords,
        dateModalTarget: search.dateModalTarget || 'self',
        departureDate: search.departureDate,
        edapActionLocation: search.actionLocation,
        edapEventRefinements: search.eventrefinements,
        keywords: search.dateModalSerpKeywords,
        locale: config.site.locale,
        messages: modules.searchBoxLite.labels,
        onSubmit: search.goToSerpAction || goToSerp,
        petIncluded: search.petIncluded,
        refinementKey: search.refinementKey || destinationSegmentKey,
        serpUrlFilters: destination.serpUrlFilters,
        showDatesModal: !!search.showDatesModal,
        thumbnailUrl: search.thumbnailUrl,
        tripleId: search.tripleId,
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

export class DateModalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasDates: !!(this.props.arrivalDate && this.props.departureDate),
        };
    }

    onDateRangeChange = (checkIn, checkOut) => {
        const {dispatch} = this.props;

        dispatch(setArrivalDate(checkIn));
        dispatch(setDepartureDate(checkOut));

        this.setState({hasDates: !!(checkIn && checkOut)});
    };

    onGuestPickerChange = (key, value) => {
        const {dispatch} = this.props;

        dispatch(
            updateSearchGuests({
                [key]: value,
            })
        );
    };

    onModalClose = () => {
        this.props.dispatch(hideDatesPopup());
    };

    onSubmit = () => {
        const {
            dateModalTarget = 'self',
            dispatch,
            keywords,
            onSubmit,
            refinementKey,
            serpUrlFilters,
            suppressFilters,
        } = this.props;

        if (keywords) {
            dispatch(setKeywords(keywords));
        }

        dispatch(
            onSubmit({
                datedSearchSubmit: this.state.hasDates,
                refinementKey,
                reportEdapEvent: false,
                serpUrlFilters,
                suppressFilters,
                target: dateModalTarget,
            })
        );

        this.props.dispatch(hideDatesPopup());
    };

    render() {
        const props = this.props;
        return (
            <DateSearchModal
                {...props}
                showGuestPicker
                onDateRangeChange={this.onDateRangeChange}
                onModalClose={this.onModalClose}
                onSubmit={this.onSubmit}
                onGuestPickerChange={this.onGuestPickerChange}
            />
        );
    }
}

export const DateModal = connect(
    mapStateToProps,
    mapDispatchToProps
)(determineIfMobile(DateModalComponent));

DateModal.displayName = 'DateModal';

export default DateModal;
